module.exports = __webpack_public_path__ + "img/gen-info.2b715f1c.png";